<template>
  <div>
    <wc-dialog
      :showDialog='showDialog'
      :title='title'
      :icon='titleIcon'
      :iconColor='titleIconColor'
      ignoreEnter
      @cancel='cancelEdit'
      @save="$emit('save', lineCopy)"
      :disableButtons='!isFormValid'
      :loadingButtons='isSavingLine'
    >
      <template v-slot:toolbarButtons>
        <wc-help-icon @help='showHelp = true'></wc-help-icon>
      </template>
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='12'>
            <v-autocomplete
              ref='item'
              label='Service Item'
              v-model='selectedService'
              :items='formattedServices'
            ></v-autocomplete>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              label='Description'
              v-model='lineCopy.description'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <vue-editor :editor-toolbar='customToolbar' v-model='lineCopy.notes'></vue-editor>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
    <wc-help
      :showHelp='showHelp'
      @closeHelp='showHelp = false'
    >
      When you select an service item from the dropdown menu,
      the description and notes fields will be auto-populated with the values
      stored in the service item in the database.<br>
      <br>
      However, you can change the description and notes as needed for this specific estimate line item.
      Changing the description and notes for this line item will not affect the service item's description and notes.
    </wc-help>
  </div>
</template>

<script>
import servicesAPI from '@/modules/assets/api/services'
import formRules from '@/mixins/formRules'
import { VueEditor } from 'vue2-editor'
import _ from 'lodash'

export default {
  name: 'estimate-line-item-dialog',
  mixins: [formRules],
  props: {
    showDialog: {
      required: true,
      type: Boolean
    },
    line: {
      required: true
    },
    estimate: {
      required: true
    },
    title: {
      required: true
    },
    titleIcon: {
      required: true
    },
    titleIconColor: {
      required: false,
      default: 'info'
    },
    isSavingLine: {
      required: false
    }
  },
  data: () => ({
    isFormValid: false,
    services: [],
    selectedService: null,
    showHelp: false,
    lineCopy: {},
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  }),
  watch: {
    showDialog () {
      if (this.showDialog) {
        this.copyLine()
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 100)
        setTimeout(() => {
          this.$refs.item.focus()
        }, 100)
      }
    },
    selectedService () {
      if (this.selectedService) {
        let serv = this.services.find(i => i.id === this.selectedService)
        this.lineCopy.description = serv.description
        this.lineCopy.notes = serv.notes
      }
    }
  },
  computed: {
    lineTotal () {
      if (this.lineCopy.price && this.lineCopy.quantity) {
        return _.multiply(this.lineCopy.price, this.lineCopy.quantity)
      }
      return 0
    },
    formattedServices () {
      let s = []
      for (let i = 0; i < this.services.length; i++) {
        s.push({
          value: this.services[i].id,
          text: this.services[i].number + ' - ' + this.services[i].description
        })
      }
      return s
    }
  },
  mounted () {
    this.getInventory()
  },
  methods: {
    async getInventory () {
      this.isLoading = true
      this.services = await servicesAPI.getServicesForDivision(this.estimate.division)
    },
    cancelEdit () {
      this.$refs.form.reset()
      this.$emit('cancel')
    },
    copyLine () {
      this.lineCopy = _.cloneDeep(this.line)
    }
  },
  components: {
    'vue-editor': VueEditor
  }
}
</script>
